export default "__VITE_ASSET__CHgQnDq7__"